import { useMemo } from 'react';
import { TableColumnConfigDto } from '@asset-metrix/portal-gateway-client-js';

export function useGroupColumnHeaderName(columns: TableColumnConfigDto[]) {
  return useMemo(
    () =>
      columns
        .filter(
          (c): c is TableColumnConfigDto & { grouping: number } =>
            c.grouping != null
        )
        .sort((a, b) => a.grouping - b.grouping)
        .map((c) => c.label)
        .join(' | '),
    [columns]
  );
}
